'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/math-intrinsics/abs.js
// module id = 5627
// module chunks = 0